import { render, staticRenderFns } from "./JobClassWork.vue?vue&type=template&id=722bd475&scoped=true&"
import script from "./JobClassWork.vue?vue&type=script&lang=js&"
export * from "./JobClassWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722bd475",
  null
  
)

export default component.exports